import { useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const PercentComplete = styled.div`
  font-size: 12px;
  animation: ${fadeIn} 1.5s ease-in;
`;

const Progress = () => {
  const progress = useSelector(({ sys }) => sys.dictation.progress) || 0;

  if (!progress || progress === 100) {
    return null;
  }

  return <PercentComplete>{progress.toFixed(0)}%</PercentComplete>;
};

export default Progress;
